import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';
import { TooltipPrimitive } from '@atlaskit/tooltip';

export const InlineDialog = styled(TooltipPrimitive)({
  background: 'white',
  borderRadius: token('border.radius', '4px'),
  boxShadow: token('elevation.shadow.overlay', '0 1px 2px rgba(0, 0, 0, 0.2)'),
  boxSizing: 'content-box',
  color: token('color.text'),
  maxHeight: '300px',
  maxWidth: '300px',
  padding: `${token('space.100', '8px')} ${token('space.150', '12px')}`,
});
